export enum ECatalogImageType {
    STOCK = 'stock',
    CUSTOM = 'custom'
}
